<template>
  <div>
    <br />
    <CCol xl="5" lg="4" md="6">
      <CCard style="text-align:center">
        <CCardHeader><h5> Click the button to download</h5> </CCardHeader>
        <CCardBody>
         
         
          <h5 v-if="spinner">Data loading...  <CSpinner color="info"/></h5>
            
 <!-- v-if="datarec" -->
          <CButton
         v-if="datarec"
            color="primary"
            class="mb-2"
            :href="csvCode"
            download="coreui-table-data.csv"
            target="_blank"
          >
            Download current items (.csv)
          </CButton>
        </CCardBody>
      </CCard>
    </CCol>

    <!-- <download-csv
	class   = "btn btn-default"
	:data   = "json_data"
	name    = "filename.csv">

	Download CSV (This is a slot)

</download-csv> -->
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import JsonCSV from "vue-json-csv";

Vue.component("downloadCsv", JsonCSV);
export default {
  data() {
    return {
      spinner: true,
      datarec: false,
      json_data: [
        {
          name: "Tony Peña",
          city: "New York",
          country: "United States",
          birthdate: "1978-03-15",
          phone: {
            mobile: "1-541-754-3010",
            landline: "(541) 754-3010",
          },
        },
        {
          name: "Thessaloniki",
          city: "Athens",
          country: "Greece",
          birthdate: "1987-11-23",
          phone: {
            mobile: "+1 855 275 5071",
            landline: "(2741) 2621-244",
          },
        },
      ],
      currentItems: [],
      arraydata: [],
      toAddress: [],
      counts: [],
      repeatarray: [],
      result: [],
    };
  },
  computed: {
    csvContent() {
      return this.repeatarray
        .map((item) => Object.values(item).join(","))
        .join("\n");
    },
    csvCode() {
      return (
        "data:text/csv;charset=utf-8,SEP=,%0A" +
        encodeURIComponent(this.repeatarray)
      );
    },
  },
  methods: {
    count(temarray) {
      var resultArr = Array();

      for (var i = 0; i < temarray.length; i++) {
        var flag = true;
        for (var j = 0; j < resultArr.length; j++) {
          if (resultArr[j][0] == temarray[i]) {
            resultArr[j][1] = resultArr[j][1] + 1;
            flag = false;
          }
        }
        if (flag) {
          resultArr.push(Array(temarray[i], 1));
        }
      }
      if (resultArr.length > 0) {
        
        this.repeatarray = resultArr.join("\n");
         this.datarec = true;
        this.spinner = false;
        
      }
     
    },
    
    getApidata() {
      let self = this;
      let temarray = [];

      // console.log("repeatarray", typeof this.repeatarray);
      var ethAddress = "0xBd3BEBDe5D5b2ed1cc6aDAdf2dadBf751aCDD1a5";
      var conAddress = "0x40CCD55B789fdEE8D434915dC2Aa6Bd938506A92";
      var pgnumber = 1;
      var processitem = function (y) {
        console.log("y", y);
        axios
          .get(
            "https://api.covalenthq.com/v1/137/address/" +
              ethAddress +
              "/transfers_v2/?contract-address=" +
              conAddress +
              "&page-size=" +
              y
          )
          .then((res) => {
            // console.log("res", res);
            console.log("total_count", res.data.data.pagination.total_count);
            console.log("page", res.data.data.pagination.page_size);
            if (
              res.data.data.pagination.total_count >
              res.data.data.pagination.page_size
            ) {
              for (let i = 0; i < res.data.data.items.length; i++) {
                for (
                  let j = 0;
                  j < res.data.data.items[i].transfers.length;
                  j++
                ) {
                  // temarray.push(res.data.data.items[i].transfers[j].to_address);
                }
                console.log("start", temarray.length);
                if (i == res.data.data.items.length - 1) {
                  let count = res.data.data.pagination.total_count;
                  console.log("count",count)
                  processitem(count);
                }
              }

              //   this.getApidata();
            } else {
                console.log("entered");
              for (let i = 0; i < res.data.data.items.length; i++) {
                for (
                  let j = 0;
                  j < res.data.data.items[i].transfers.length;
                  j++
                ) {
                  temarray.push(res.data.data.items[i].transfers[j].to_address);
                }
                console.log("start2", temarray.length);
                if (i == res.data.data.items.length - 1) {
                  //   let count = res.data.data.pagination.total_count ;
                  // console.log("count",count)
                  //   processitem(count);
                  self.count(temarray);
                }
              }
            }

            console.log("repeatarray3", temarray.length);
          });
      };
      processitem(100);
    },
  },
  created() {
    this.getApidata();
  },
};
</script>
<style src="spinkit/spinkit.min.css"></style>
